import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { GetTeamsBulkResponse } from './types';

const TEAMS_BULK_REST_API_URL = '/gateway/api/v3/teams/withMembers/bulk';

export const getTeams = async (teamIds: string[]) =>
	performPostRequest<GetTeamsBulkResponse>(TEAMS_BULK_REST_API_URL, {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(teamIds),
	});

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { TeamRecord } from './types';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mockGetTeamsSuccess, mockGetTeamsFailure } from './mocks';
